"use client"

import CareerPaths from "./CareerPaths"
import DashboardLayout from "@/views/dashboard/DashboardLayout"

export default function CareerPathsPage() {
  return (
    <DashboardLayout>
      <CareerPaths />
    </DashboardLayout>
  )
}
